import { render } from "./draftsManage.vue?vue&type=template&id=b894d8e0"
import script from "./draftsManage.vue?vue&type=script&lang=js"
export * from "./draftsManage.vue?vue&type=script&lang=js"

import "./draftsManage.vue?vue&type=style&index=0&id=b894d8e0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__